var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup345(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_345",
    "data-name": "Group 345",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.151,
    height: 51.147,
    viewBox: "0 0 51.151 51.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M-502.608,126.81a25.53,25.53,0,0,1,25.547,25.6,25.529,25.529,0,0,1-25.6,25.547A25.534,25.534,0,0,1-528.212,152.4,25.523,25.523,0,0,1-502.608,126.81Zm-4.1,38.679,19.524-19.514-4.492-4.511-15.053,15.054-6.931-6.95-4.482,4.487Z",
    transform: "translate(528.212 -126.81)",
    fill: "#54b33c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup345);
export default __webpack_public_path__ + "static/media/Group 345.74a75995df14f56747fc6b09b08b2ef1.svg";
export { ForwardRef as ReactComponent };